import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { userData } from "@/types/mainTypes";

export type AuthState = {
  user: userData | null;
  token: string | null;
  isValid: boolean;
};

const initialState: AuthState = {
  user: null,
  token: null,
  isValid: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCredentials: (state, { payload }: PayloadAction<AuthState>) => {
      state.token = payload.token;
      state.user = payload.user;
      state.isValid = payload.isValid;
    },
    clearCredentials: (state) => {
      state.token = null;
      state.user = null;
    },
  },
});

export const { setCredentials, clearCredentials } = authSlice.actions;
export default authSlice.reducer;
